import React, { useEffect, useState } from "react";
import { getCountry } from "../../../API/Lists/country";
import { HiChevronDown } from "react-icons/hi";
import "./customSelect.sass";

const CustomSelect = ({ label, value, list, propriety, onChange, name, customId }) => {
  return (
    <div className="form-group">
      <div className="custom-label fw-bold" style={{ color: "#CACCFC" }}>
        {label}
      </div>
      <div className="d-flex">
        <select name={name} onChange={onChange} value={value || ""} className="form-control mt-2 p-0 mb-1 custom-select">
          <option style={{ backgroundColor: "#281c44", color: "white" }} value={0} data-index={0}>
            Seleccione
          </option>
          {list &&
            list.map((item) => (
              <option value={item.customId ?? item.id} style={{ backgroundColor: "#281c44", color: "white" }} key={item.id}>
                {item[propriety] ?? item}
              </option>
            ))}
        </select>
        <HiChevronDown className="mt-2" />
      </div>
      <div className="input-underline"></div>
    </div>
  );
};

export default CustomSelect;
